import React from 'react'
import { Grid } from '@mui/material'
import Header from './header'
import LpqBody from './body'
import LpqFooter from './footer'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ typography, spacing, palette }) => ({
  root: {
    height: '100%'
  }
}))

const LpqPage = ({ title, content, footer, onClose }) => {
  const classes = useStyles()

  return (
    <Grid
      container
      direction='column'
      alignItems='center'
      wrap='nowrap'
      className={classes.root}
    >
      <Header title={title} onClose={onClose} />
      <LpqBody>{content}</LpqBody>
      <LpqFooter>{footer}</LpqFooter>
    </Grid>
  )
}

export default LpqPage
